var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { TableRedux } from 'app/components/Table/TableRedux';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { permission } from 'app/containers/Permissions';
import history from 'app/main/routerHistory';
import { setUserSettings } from 'app/libs/helpers/userSettings';
import { SendEvent } from 'app/core/utils/SendEvent.js';
import { updateFUAsset, resetFollowUpAssets, fetchAssets } from 'app/store/reducers/assets';
import { isBoolean, find, forEach, map, padEnd, reduce, head, filter, isEmpty, flatten } from 'lodash';
import { getLastTakeFromTask, getLastTakeFromAsset, getCalculatedFieldType, } from 'app/pages/Project/ProductionManagement/FollowUp/utilsTS';
import { TimelineCellComponent } from 'app/components/Table/Cells/ColumnTimeline/CellComponents/TimelineCellComponent';
import { TimelineDrawerComponentActivities } from 'app/components/Table/Cells/ColumnTimeline/CellComponents/Drawers';
import resources from 'app/store/resources';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { Tooltip } from 'app/components/Tooltip/Tooltip.jsx';
import { viewableValue } from 'app/components/Form/FormData/getInput';
import store from 'app/store/index';
import { colors } from 'app/styles/colors';
import { CellLink, CellTask, CellThumbnail, CellText, CellDuration, CellProgression, CellRichText, CellFlags, CellSelect, CellRating, CellCheckbox, CellPriority, CellMedias, CellAssetsList, CellTimecode, CellAggregatedAttribute, CellDynamicApproval, CellAssetsSelect, CellNotesFollowUp, CellStatus, CellAggregatedDynamicApproval, CellSmartDate, ColumnTimeline, } from 'app/components/Table/Cells';
import { CellStatsDefault, CellStatsStatus, CellStatsAssignedUsers, CellStatsStep, CellStatsAttributes, CellStatsFlags, CellStatsDynamicApprovals, CellStatsCalculatedFields, CellStatsAssetLinks, } from 'app/components/Table/Cells/StatsCells/index.js';
import { assetIcons } from 'app/components/Icons/assetsIcons.js';
import { router } from 'app/containers/Assets/AssetDetail/router';
import { regex, dateToLocaleStringFull } from 'app/libs/helpers/index.js';
import { getResources } from 'app/store/selectors';
import { accessorTakeMedias } from 'app/components/Table/Cells/CellMedias/utils.js';
import moment from 'moment';
import { getEpisodes } from 'app/store/selectors/getEpisodes.js';
import { DurationRead } from 'app/components/Duration/Duration';
import { userPrefLocalResource } from 'app/core/utils/localUserPrefs.js';
import { tablePageSelector, tableUserPrefsDataSelector, tableUserPrefsSortBySelector, } from 'app/store/selectors/tableUserPrefs';
import { reduxAssetsReducer, tableFUDataWithRelationsSelector } from 'app/store/selectors/assets';
import { resetAllTasks, updateTask } from 'app/store/reducers/tasks';
import useWebsocket from 'app/core/api/useWebSocket';
import { updateTake } from 'app/store/reducers/takes';
import { createAndDeleteTakeFlags, createTakeFlags, deleteTakeFlags } from 'app/store/reducers/takesFlags';
import { createPostBoardNote, updatePostBoardNote } from 'app/store/reducers/reduxPostBoardNotes';
import { updateAndDeleteAssetLinks } from 'app/store/reducers/reduxAssetLinks';
import { filtersToURL, urlToFilters, filtersToQueries } from 'app/components/Table/hooks/useFiltersUtils.js';
import { createUpdateAndDeleteDynamicApprovalValue } from 'app/store/reducers/reduxDynamicApprovalValues';
import { createAndDeleteAssetFlags } from 'app/store/reducers/reduxAssetFlags';
import { deleteMedias } from 'app/store/reducers/reduxMedias';
import { createTakeValidationMedia } from 'app/store/reducers/reduxTakeValidationMedias';
import { Filters } from 'app/pages/Project/ProductionManagement/FollowUp/Filters.js';
import { tableFiltersDataSelector, tableFiltersForQueriesSelector } from 'app/store/selectors/tablesFilters';
import routerHistory from 'app/main/routerHistory.js';
import { getURLParamsKey } from 'app/components/Table/utils.js';
import { resetReduxFilters, setAndApplyInputFilters } from 'app/store/reducers/tablesFilters';
import { useLocation } from 'react-router-dom';
import { createTakeRefMedia } from 'app/store/reducers/reduxTakeRefMedias';
import { setStatsOpen } from 'app/store/reducers/stats';
import { createPostBoardLink } from 'app/store/reducers/reduxPostboardLinks';
import { setTablePage } from 'app/store/reducers/tablesPrefs';
import { assetsTypes } from 'app/core/constants/assetsTypes';
import { statsStatusSelector } from 'app/store/selectors/stats';
const TableFollowUpRedux = (props) => {
    var _a, _b, _c, _d, _e;
    const { asset, trackingSchema, extendToolbar, projectId, permissions: propsPermissions, lockFilters, tableId } = props;
    useWebsocket();
    const dispatch = useDispatch();
    const { search } = useLocation();
    const table = (_a = userPrefLocalResource.getData('tables')) === null || _a === void 0 ? void 0 : _a[tableId];
    // local states
    const [showGantt, setShowGantt] = useState(false);
    const [ganttColorsType, setGanttColorsType] = useState('step');
    const [URLParamsParsed, setURLParamsParsed] = useState(false);
    const [allFilters, setAllFilters] = useState([]);
    // new selectors
    const { loading, count, httpProgress, stats, statsIsLoading } = useSelector(reduxAssetsReducer);
    const data = useSelector(tableFUDataWithRelationsSelector);
    const statsOpen = useSelector(statsStatusSelector);
    const reduxPage = useSelector(tablePageSelector);
    const trackingSchemas = useSelector((state) => { var _a; return (_a = state.trackingSchemas) === null || _a === void 0 ? void 0 : _a.resources; }) || [];
    const filtersData = (_b = useSelector(tableFiltersDataSelector)) !== null && _b !== void 0 ? _b : [];
    const filtersForQueries = useSelector(tableFiltersForQueriesSelector);
    const tableUserPrefs = useSelector(tableUserPrefsDataSelector(tableId));
    const ordering = (_c = useSelector(tableUserPrefsSortBySelector(tableId))) === null || _c === void 0 ? void 0 : _c.orderingString;
    // old selectors
    const progressionStatus = useMemo(() => getResources(undefined, 'progressionStatus'), []);
    const episodes = useMemo(() => getEpisodes(), []);
    const steps = useMemo(() => getResources(undefined, 'steps'), []);
    const attributes = useMemo(() => getResources(undefined, 'attributes'), []);
    const dynamicApprovals = useMemo(() => getResources(undefined, 'dynamicApprovals', { project: projectId }), []);
    const filtersFromTrackingSchemas = [];
    useEffect(() => {
        return () => {
            dispatch(setStatsOpen(false));
            dispatch(resetAllTasks());
            dispatch(resetFollowUpAssets());
        };
    }, []);
    // WIP to clean
    useEffect(() => {
        var _a;
        (_a = Object.values(trackingSchemas)) === null || _a === void 0 ? void 0 : _a.forEach((ts) => {
            ts.schema.forEach((schema) => {
                if (schema === null || schema === void 0 ? void 0 : schema.type) {
                    filtersFromTrackingSchemas.push(schema === null || schema === void 0 ? void 0 : schema.items);
                }
            });
        });
        const filters = new Filters({
            columns: filtersFromTrackingSchemas.flat().filter((_) => _),
            attributes,
            // assetType: trackingSchema.assetType,
        }).getFilters();
        setAllFilters(filters);
    }, [trackingSchemas]);
    const filters = useMemo(() => {
        if (trackingSchema) {
            return new Filters({
                columns: flatten(trackingSchema.schema.map((groupColumn) => groupColumn.items)),
                attributes,
                assetType: trackingSchema.assetType,
            }).getFilters();
        }
        return [];
    }, [trackingSchema, attributes]);
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (search && (filters === null || filters === void 0 ? void 0 : filters.length)) {
                const params = new URLSearchParams(search);
                const urlCurrentFilters = params.get(getURLParamsKey('filters', tableId));
                if (urlCurrentFilters) {
                    const urlFilters = yield urlToFilters(urlCurrentFilters, filters, undefined, undefined, false);
                    dispatch(setAndApplyInputFilters(urlFilters));
                }
            }
            if (!search && (filters === null || filters === void 0 ? void 0 : filters.length) && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.length) && !lockFilters) {
                dispatch(resetReduxFilters());
            }
            setURLParamsParsed(true);
        }))();
    }, [filters]);
    const exportExcelFormat = useMemo(() => {
        if (asset && trackingSchema) {
            return {
                assetId: asset.id,
                data: { trackingSchema },
                type: 'trackingSchema',
            };
        }
        return undefined;
    }, [asset, trackingSchema]);
    function fitToActivities(task, instance) {
        var _a, _b, _c, _d, _e, _f;
        const secondesToDays = (sec) => sec / 60 / 60 / 7.8;
        const activities = task.activitiesInst.sort((a, b) => moment(a.date, 'DD-MM-YYYY').diff(moment(b.date, 'DD-MM-YYYY')));
        const activitiesTot = activities.reduce((acc, act) => acc + act.duration, 0);
        const estim = Math.max(reduce(task.takesInst, (acc, take) => take.estimLength + acc, 0), // all takes estim
        task.realEstimLength || 0) ||
            task.quoteEstimLength ||
            0;
        const activitiesPerc = (activitiesTot / 100) * 95;
        let activitiesSum = 0;
        const startDate = ((_a = activities === null || activities === void 0 ? void 0 : activities[0]) === null || _a === void 0 ? void 0 : _a.date) ? moment((_b = activities === null || activities === void 0 ? void 0 : activities[0]) === null || _b === void 0 ? void 0 : _b.date) : moment(task.startDate);
        let endDate = null;
        if ([1].includes((_c = task.statusInst) === null || _c === void 0 ? void 0 : _c.statusType)) {
            const estimDays = secondesToDays(estim);
            endDate = moment(startDate).add(estimDays, 'days');
        }
        // DONE   WAITING FOR APPROVAL   CLOSED
        else if ([2, 3].includes((_d = task.statusInst) === null || _d === void 0 ? void 0 : _d.statusType) || estim === 0) {
            for (let i = 0; i < activities.length; i += 1) {
                const act = activities[i];
                activitiesSum += act.duration;
                if (activitiesSum >= activitiesPerc) {
                    endDate = moment(act.date, 'YYYY-MM-DD');
                    break;
                }
            }
        }
        // UNAPPROVED   STAND BY   WORK IN PROGRESS  TO DO
        else if ([0, 4, 5].includes((_e = task.statusInst) === null || _e === void 0 ? void 0 : _e.statusType)) {
            if (estim) {
                if (activitiesTot <= estim) {
                    let diff = secondesToDays(estim - activitiesTot);
                    endDate = moment();
                    while (diff > 0) {
                        if ([6, 0].includes(endDate.day())) {
                            endDate.add(1, 'day');
                            continue;
                        }
                        endDate.add(1, 'day');
                        diff -= 1;
                    }
                }
                else if (activitiesTot > estim) {
                    let diff = secondesToDays(estim * 0.1);
                    endDate = moment();
                    while (diff > 0) {
                        if ([6, 0].includes(endDate.day())) {
                            endDate.add(1, 'day');
                            continue;
                        }
                        endDate.add(1, 'day');
                        diff -= 1;
                    }
                }
            }
        }
        if (startDate && endDate && (startDate === null || startDate === void 0 ? void 0 : startDate.isSameOrBefore(endDate))) {
            return (_f = resources.tasks) === null || _f === void 0 ? void 0 : _f.update({ id: task.id, startDate: startDate.toISOString(), endDate: endDate === null || endDate === void 0 ? void 0 : endDate.toISOString() }).then(() => {
                const { cell, updateCells } = instance;
                updateCells({ [cell.id]: cell });
            });
        }
        return Promise.resolve();
    }
    const { directoryId, assetId } = useMemo(() => {
        if (asset) {
            if (['sh', 'mo'].includes(asset.assetType)) {
                return { directoryId: asset.parent, assetId: asset.id };
            }
            return { directoryId: asset.id, assetId: undefined };
        }
        return { directoryId: undefined, assetId: undefined };
    }, [asset]);
    const permissions = useMemo(() => propsPermissions || {
        assets: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_assets'], 'or'),
        attributes: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_attributes'], 'or'),
        tasks: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_tasks'], 'or'),
        takes: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_takes'], 'or'),
        steps: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_steps'], 'or'),
        dynApp: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_dynamic approvals'], 'or'),
        notes: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_notes'], 'or'),
        assetLinks: permission(['projet_follow-up__update', 'projet_follow-up_update only columns_asset links'], 'or'),
        timeline: {
            read: permission([
                'projet_follow-up_timeline_read',
                'projet_follow-up_timeline_update start/end dates',
                'projet_follow-up_timeline_update earliest/latest dates',
            ], 'or'),
            startEndUpdate: permission(['projet_follow-up_timeline_update start/end dates']),
            earliestLatestUpdate: permission(['projet_follow-up_timeline_update earliest/latest dates']),
        },
    }, [propsPermissions]);
    function toggleButtons(instance) {
        const buttons = [];
        const showConfig = permission([
            'projet_follow-up_table management_create',
            'projet_follow-up_table management_update',
            'projet_follow-up_table management_delete',
        ], 'or');
        if (showConfig && trackingSchema) {
            buttons.push({
                key: 'config',
                children: 'Config',
                onClick: () => history.push(`/projects/${projectId}/settings/follow-up/${trackingSchema.id}`),
                icon: 'fas-cog',
                style: { border: `1px solid ${colors.yuzuBlack}` },
            });
        }
        if (permissions.timeline.read) {
            buttons.push({
                key: 'showGantt',
                tooltip: 'Show timeline',
                icon: 'fas-stream',
                style: { border: `1px solid ${colors.yuzuBlack}` },
                selected: showGantt,
                onClick: (e) => setShowGantt((sg) => {
                    setUserSettings(`${tableId || 'table-follow-up-'}-showGantt`, !sg);
                    return !sg;
                }),
                options: [
                    {
                        key: 'showGantt-status',
                        label: 'Status color',
                        onClick: () => {
                            setShowGantt(true);
                            setGanttColorsType('status');
                            setUserSettings(`${tableId || 'table-follow-up-'}-ganttColors`, 'status');
                        },
                        icon: 'fas-traffic-light',
                        selected: ganttColorsType === 'status',
                    },
                    {
                        key: 'showGantt-step',
                        label: 'Step color',
                        onClick: () => {
                            setShowGantt(true);
                            setGanttColorsType('step');
                            setUserSettings(`${tableId || 'table-follow-up-'}-ganttColors`, 'step');
                        },
                        icon: 'fas-tasks',
                        selected: ganttColorsType === 'step',
                    },
                ],
            });
        }
        const showSendEvent = permission(['projet_follow-up__send events to sentry']);
        if (showSendEvent && trackingSchema) {
            const { queries: filtQueries } = filtersToQueries(filtersForQueries !== null && filtersForQueries !== void 0 ? filtersForQueries : []);
            buttons.push({
                key: 'sendEvent-ttPlayer',
                label: 'Open in TTPlayer',
                icon: 'fas-film',
                style: { border: `1px solid ${colors.yuzuBlack}` },
                onClick: () => {
                    SendEvent(instance, 'ttplayer', ordering, filtQueries);
                },
                options: [
                    {
                        key: 'sendEvent-askSofts',
                        label: 'Send to tools',
                        onClick: () => {
                            SendEvent(instance, 'askSoft', ordering, filtQueries);
                        },
                        icon: 'fas-terminal',
                    },
                ],
            });
        }
        return buttons;
    }
    const restrictedActions = (_e = (_d = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _d === void 0 ? void 0 : _d.restrictedActions) !== null && _e !== void 0 ? _e : [];
    function renderLastTakeCell(column) {
        var _a;
        const { description, color, columnName, name, hiddenable, isVisible = true, hidden, readOnly, fixable, fixed, attr, step, timestamp, } = column;
        const cellContent = {
            Header: columnName || name,
            description,
            headerColor: color,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            sortingKey: `lastTake_${step}_${attr}`,
            readOnly: !permissions.takes || (isBoolean(readOnly) ? readOnly : false),
            draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
            id: String(timestamp),
            accessor: (item) => {
                if (!item)
                    return undefined;
                const lastTake = getLastTakeFromAsset(item, column);
                if (!lastTake)
                    return undefined;
                return lastTake[attr] || null;
            },
            actions: (tableInstance, cell) => {
                const lastTake = getLastTakeFromAsset(cell.row.original, column);
                return lastTake ? ['edit', 'copy', 'past'] : [];
            },
            reduxSave: {
                bulk: true,
                reduxAction: (values) => dispatch(updateTake(values)),
                getData: (data, newValue) => {
                    const lastTake = getLastTakeFromAsset(data, column);
                    if (!lastTake)
                        return null;
                    return {
                        id: lastTake && lastTake.id,
                        [attr]: newValue,
                    };
                },
            },
            Placeholder: (instance) => {
                var _a;
                const lastTake = getLastTakeFromAsset((_a = instance === null || instance === void 0 ? void 0 : instance.cell) === null || _a === void 0 ? void 0 : _a.row.original, column);
                if (!lastTake)
                    return _jsx("div", { className: "fullHeight flex center alignCenter lightgrey fontSize11", children: "No task" });
                return undefined;
            },
        };
        switch (attr) {
            case 'estimLength':
                return CellDuration(Object.assign(Object.assign({}, cellContent), { Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "takes", fields: ['estimLength'] }));
                    }, actions: (tableInstance, cell) => {
                        const lastTake = getLastTakeFromAsset(cell.row.original, column);
                        return lastTake ? ['edit', 'copy', 'past'] : [];
                    } }));
            case 'number':
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: { type: 'number' }, noFilterOption: true, actions: (tableInstance, cell) => (regex.exist(cell.value) ? ['copy'] : []), Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "takes", fields: ['number__counts'], updateFields: (entry) => ({
                                'Take number': entry.fTakes__number,
                                count: entry.count,
                            }) }));
                    } }));
            case 'takeFlagsInst':
                return CellFlags(Object.assign(Object.assign({}, cellContent), { foreignKey: 'take', category: 'take', sortingKey: undefined, actions: (tableInstance, cell) => {
                        const lastTake = getLastTakeFromAsset(cell.row.original, column);
                        return lastTake ? ['edit', 'delete', 'copy', 'past'] : [];
                    }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => {
                            const flagsToCreate = values.flatMap((val) => val === null || val === void 0 ? void 0 : val.flagsToCreate).filter((_) => _);
                            const flagsToDelete = values.flatMap((val) => val === null || val === void 0 ? void 0 : val.flagsToDelete).filter((_) => _);
                            return dispatch(createAndDeleteTakeFlags({ flagsToCreate, flagsToDelete }));
                        },
                        getData: (data, newValue, type) => {
                            const lastTake = getLastTakeFromAsset(data, column);
                            if (!lastTake)
                                return null;
                            if (type === 'delete') {
                                return { flagsToDelete: lastTake.takeFlagsInst, flagsToCreate: [] };
                            }
                            const previousTakeFlags = lastTake.takeFlagsInst;
                            const newFlagsIds = map(newValue, (flag) => flag.flag);
                            const previousFlagsIds = previousTakeFlags.map((flag) => flag.flag);
                            const flagsToCreate = map(newValue)
                                .filter((flagToSave) => !previousFlagsIds.includes(flagToSave.flag))
                                .map((flag) => ({ take: lastTake.id, flag: flag.flag }));
                            const flagsToDelete = previousTakeFlags.filter((previousFlag) => !newFlagsIds.includes(previousFlag.flag));
                            return { flagsToCreate, flagsToDelete: type === 'merge' ? [] : flagsToDelete };
                        },
                    }, getResourceID: (cell) => { var _a; return (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.id; } }));
            case 'status':
                return CellStatus(Object.assign(Object.assign({}, cellContent), { progressionStatus, Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsStatus, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), progressionStatus: progressionStatus, columnName: columnName }));
                    }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => dispatch(updateTake(values)),
                        getData: (data, newValue) => {
                            const lastTake = getLastTakeFromAsset(data, column);
                            if (!lastTake)
                                return null;
                            return {
                                id: lastTake.id,
                                status: newValue,
                            };
                        },
                    } }));
            case 'takeValidationMediasInst':
                return CellMedias(Object.assign(Object.assign({}, cellContent), { accessor: (item) => {
                        if (!item)
                            return undefined;
                        const lastTake = getLastTakeFromAsset(item, column);
                        if (!lastTake)
                            return undefined;
                        const { takeValidationMediasInst } = lastTake;
                        return accessorTakeMedias(takeValidationMediasInst);
                    }, sortingKey: undefined, allowPinMedia: true, allowValidateMedia: true, actions: () => ['edit', 'delete'], reduxSave: {
                        bulk: true,
                        reduxAction: (values) => {
                            const toCreate = values.flatMap((val) => val.toCreate).filter((_) => _);
                            const toDelete = values.flatMap((val) => val.toDelete);
                            const promises = [
                                toCreate.length && dispatch(createTakeValidationMedia(toCreate)),
                                toDelete.length && dispatch(deleteMedias(toDelete)),
                            ];
                            return Promise.all(promises);
                        },
                        getData: (data, newValue, type, instance, cell) => {
                            if (!data)
                                return null;
                            const lastTake = getLastTakeFromAsset(data, column);
                            if (!lastTake)
                                return null;
                            if (type === 'delete') {
                                if (!cell.value)
                                    return null;
                                return { toDelete: map(cell.value, (media) => media.id) };
                            }
                        },
                    } }));
            case 'takeRefMediasInst':
                return CellMedias(Object.assign(Object.assign({}, cellContent), { accessor: (item) => {
                        if (!item)
                            return undefined;
                        const lastTake = getLastTakeFromAsset(item, column);
                        if (!lastTake)
                            return undefined;
                        const { takeRefMediasInst } = lastTake;
                        return accessorTakeMedias(takeRefMediasInst);
                    }, sortingKey: undefined, allowPinMedia: true, allowValidateMedia: true, actions: () => ['edit', 'delete'], reduxSave: {
                        bulk: true,
                        reduxAction: (values) => {
                            const toCreate = values.flatMap((val) => val.toCreate).filter((_) => _);
                            const toDelete = values.flatMap((val) => val.toDelete);
                            const promises = [
                                toCreate.length && dispatch(createTakeRefMedia(toCreate)),
                                toDelete.length && dispatch(deleteMedias(toDelete)),
                            ];
                            return Promise.all(promises);
                        },
                        getData: (data, newValue, type, instance, cell) => {
                            if (!data)
                                return null;
                            const lastTake = getLastTakeFromAsset(data, column);
                            if (!lastTake)
                                return null;
                            if (type === 'delete') {
                                if (!cell.value)
                                    return null;
                                return { toDelete: map(cell.value, (media) => media.id) };
                            }
                            const { toCreate, toDelete } = newValue;
                            return { toCreate: toCreate.length ? { take: lastTake.id, medias: toCreate } : [], toDelete };
                        },
                    } }));
            case 'comment':
                return CellRichText(Object.assign(Object.assign({}, cellContent), { actions: (tableInstance, cell) => {
                        const lastTake = getLastTakeFromAsset(cell.row.original, column);
                        return lastTake ? ['edit', 'copy', 'past', 'delete'] : [];
                    }, width: 200, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const lastTake = getLastTakeFromAsset(item, column);
                        if (!lastTake)
                            return undefined;
                        return lastTake[attr] || '';
                    }, showHistoryParams: (instance, cell) => {
                        const { row: { original }, } = cell;
                        const lastTake = getLastTakeFromAsset(original, column);
                        if (!lastTake)
                            return null;
                        return {
                            assetId: lastTake.id,
                            projectId,
                            resourceType: 'takes',
                            title: 'Comment',
                            requestName: 'history',
                            accessor: 'comment',
                        };
                    } }));
            case 'validationComment':
                return CellRichText(Object.assign(Object.assign({}, cellContent), { actions: (tableInstance, cell) => {
                        const lastTake = getLastTakeFromAsset(cell.row.original, column);
                        return lastTake ? ['edit', 'copy', 'past', 'delete'] : [];
                    }, width: 200, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const lastTake = getLastTakeFromAsset(item, column);
                        if (!lastTake)
                            return undefined;
                        return lastTake[attr] || '';
                    }, showHistoryParams: (instance, cell) => {
                        const { row: { original }, } = cell;
                        const take = getLastTakeFromAsset(original, column);
                        if (!take)
                            return null;
                        return {
                            assetId: take.id,
                            projectId,
                            resourceType: 'takes',
                            title: 'Validation comment',
                            requestName: 'history',
                            accessor: 'validationComment',
                        };
                    } }));
            case 'name':
                return CellText(Object.assign(Object.assign({}, cellContent), { Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "takes", updateFields: (entry) => {
                                if (typeof entry === 'object' && entry.fTakes__number) {
                                    return {
                                        'Take number': entry.fTakes__number,
                                        count: entry.count,
                                    };
                                }
                                return entry;
                            } }));
                    } }));
            default:
                throw new Error(`unknow lastTake attr ${attr}`);
        }
    }
    function renderAssetLinks(column) {
        var _a, _b;
        const { hiddenable, isVisible = true, hidden, fixed, fixable, readOnly, category, description, columnName, name, timestamp, length, } = column;
        if (length) {
            return CellText({
                Header: columnName || name,
                description,
                id: String(timestamp),
                hiddenable: isBoolean(hiddenable) ? hiddenable : true,
                hiddenByDefault: !isVisible,
                hidden,
                fixable: isBoolean(fixable) ? fixable : true,
                fixed,
                readOnly: !permissions.assetLinks || (isBoolean(readOnly) ? readOnly : false),
                draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
                accessor: (item) => {
                    if (!item)
                        return [];
                    return filter(item.assetLinksInst, (link) => link.to_assetInst.attributes.category === category).length;
                },
                width: 30,
            });
        }
        return CellAssetsList({
            Header: columnName || name,
            description,
            id: String(timestamp),
            disableClickableAssets: restrictedActions.includes('assetSheet'),
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            readOnly: !permissions.assetLinks || (isBoolean(readOnly) ? readOnly : false),
            draggable: !((_b = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _b === void 0 ? void 0 : _b.lockColumnOrder),
            searchFilterLabel: 'Linked assets',
            filterLabel: 'Linked assets',
            accessor: (item) => {
                return filter(item.assetLinksInst, (link) => link.to_assetInst.attributes.category === category);
            },
            width: 200,
            category,
            actions: () => ['edit', 'copy', 'past', ...(permission(['projet_breakdown_links_delete']) ? ['delete'] : [])].filter((_) => _),
            onOpenItem: (asset) => {
                router.goTo('index', { assetId: asset.id }, { rightPanel: true });
            },
            reduxSave: {
                bulk: true,
                reduxAction: (values) => {
                    const assetLinksToUpdate = values.flatMap((val) => val.assetLinksToUpdate).filter((_) => _);
                    const assetLinksIdsToDelete = values
                        .flatMap((val) => val.assetLinksToDelete)
                        .filter((_) => _)
                        .map((id) => ({ id }));
                    return dispatch(updateAndDeleteAssetLinks({ assetLinksToUpdate, assetLinksIdsToDelete }));
                },
                getData: (data, newValue, type, instance, cell) => {
                    if (type === 'merge') {
                        if (map(newValue).length === 0)
                            return null;
                        return {
                            assetLinksToUpdate: map(newValue.filter((rel) => { var _a; return rel.to_assetInst.attributes.category === ((_a = cell.column.extends) === null || _a === void 0 ? void 0 : _a.category); }), (link) => ({
                                from_asset: data.id,
                                datas: undefined,
                                to_asset: link.to_assetInst.id,
                                linkType: column === null || column === void 0 ? void 0 : column.id,
                                id: undefined,
                                to_assetInst: newValue === null || newValue === void 0 ? void 0 : newValue.to_assetInst,
                            })),
                            assetLinksToDelete: [],
                        };
                    }
                    if (type === 'past') {
                        if (map(newValue).length === 0)
                            return null;
                        return {
                            assetLinksToUpdate: newValue
                                .filter((rel) => { var _a; return rel.to_assetInst.attributes.category === ((_a = cell.column.extends) === null || _a === void 0 ? void 0 : _a.category); })
                                .map((link) => ({
                                from_asset: data.id,
                                datas: undefined,
                                to_asset: link.to_assetInst.id,
                                linkType: column === null || column === void 0 ? void 0 : column.id,
                                id: undefined,
                                to_assetInst: newValue === null || newValue === void 0 ? void 0 : newValue.to_assetInst,
                            })),
                            assetLinksToDelete: cell.value.map((link) => link.id),
                        };
                    }
                    if (type === 'delete') {
                        return { assetLinksToUpdate: [], assetLinksToDelete: cell.value.map((link) => link.id) };
                    }
                    const { toCreate, toDelete } = newValue;
                    const toCreateByColumn = toCreate.filter((rel) => {
                        var _a, _b;
                        const relCategory = (_b = (_a = rel.assetInst) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.category;
                        const { category } = cell.column.extends || {};
                        if (!relCategory || !category)
                            return false;
                        return relCategory === category && rel.from_asset === data.id;
                    });
                    return { assetLinksToUpdate: toCreateByColumn, assetLinksToDelete: toDelete };
                },
            },
            Stats: (instance) => _jsx(CellStatsAssetLinks, { instance: instance, category: category }),
        });
    }
    function renderAssetCell(column) {
        var _a;
        const { readOnly, isVisible = true, hidden, columnName, name, fixable, hiddenable, fixed, attr = '', type, color, timestamp, } = column;
        const cellContent = {
            Header: columnName || name,
            headerColor: color,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            readOnly: !permissions.assets || (isBoolean(readOnly) ? readOnly : false),
            draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
            id: String(timestamp),
            accessor: attr,
            actions: () => ['edit', 'copy'],
            reduxSave: {
                bulk: true,
                reduxAction: (values) => console.log('values', values),
                getData: (data, newValue) => {
                    return {
                        id: data.id,
                        [attr]: newValue,
                    };
                },
            },
        };
        switch (attr) {
            case 'assetFlagsInst':
                return CellFlags(Object.assign(Object.assign({}, cellContent), { accessor: (item) => {
                        return item.assetFlagsInst;
                    }, category: (cell) => { var _a; return (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.assetType; }, actions: () => ['edit', 'copy', 'past', 'delete'], foreignKey: 'asset', getResourceID: (cell) => { var _a; return (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.id; }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => {
                            const flagsToCreate = values.flatMap((val) => val.flagsToCreate).filter((_) => _);
                            const flagsToDelete = values.flatMap((val) => val.flagsToDelete).filter((_) => _);
                            return dispatch(createAndDeleteAssetFlags({ flagsToCreate, flagsToDelete }));
                        },
                        getData: (data, newValue, type, instance, cell) => {
                            if (type === 'delete') {
                                const flagsToDelete = cell.value;
                                return { flagsToDelete };
                            }
                            const newFlags = map(newValue, ({ flagInst }) => ({
                                asset: data.id,
                                flag: flagInst.id,
                            }));
                            const previousFlags = cell.value;
                            const previousFlagsIds = previousFlags.map((flag) => flag === null || flag === void 0 ? void 0 : flag.flag);
                            const newFlagsIds = newFlags.map((flag) => flag === null || flag === void 0 ? void 0 : flag.flag);
                            const flagsToCreate = newFlags
                                .filter((flagToSave) => !previousFlagsIds.includes(flagToSave.flag))
                                .map((flag) => ({ asset: data.id, flag: flag.flag }));
                            const flagsToDelete = previousFlags.filter((previousFlag) => !newFlagsIds.includes(previousFlag.flag));
                            return {
                                flagsToCreate,
                                flagsToDelete: type === 'merge' ? [] : flagsToDelete,
                            };
                        },
                    }, Stats: (instance) => {
                        return _jsx(CellStatsFlags, { instance: instance, columnName: columnName });
                    } }));
            case 'thumbnailInst':
                return CellThumbnail(Object.assign(Object.assign({}, cellContent), { reduxSave: {
                        bulk: true,
                        reduxAction: (values) => dispatch(updateFUAsset(values)),
                        getData: (data, newValue) => {
                            return {
                                id: data.id,
                                thumbnail: newValue.id,
                            };
                        },
                    } }));
            case 'assetType':
                return CellText(Object.assign(Object.assign({}, cellContent), { actions: () => [], RenderRead: (cell, value) => (_jsxs("div", { className: "flex row alignCenter", children: [_jsx(FontIcon, { icon: assetIcons(value), className: "marginRight5" }), assetsTypes[value]] })), save: {
                        resource: 'assets',
                    } }));
            case 'parentInst':
                return CellAssetsSelect(Object.assign(Object.assign({}, cellContent), { actions: () => [], placeholder: 'Asset parent', readOnly: true, sortingKey: 'parent__name', save: {
                        resource: 'assets',
                    } }));
            default:
                throw new Error(`unknow asset attr ${column.attr}`);
        }
    }
    function renderNotesCell(column) {
        const { step, description, columnName, name, timestamp, hiddenable, isVisible = true, hidden, fixable, fixed, } = column;
        const readOnly = !permissions.notes || (isBoolean(column.readOnly) ? column.readOnly : false);
        if (step && step.assetType === 'sh') {
            const findNote = (postBoardLinksInst) => {
                if (!postBoardLinksInst)
                    return null;
                const postBoardLink = map(postBoardLinksInst)[0];
                const note = find(postBoardLink === null || postBoardLink === void 0 ? void 0 : postBoardLink.notesInst, ({ step: noteStep }) => {
                    if (noteStep === step.id || (noteStep === null && step.id === 'general'))
                        return true;
                    return false;
                });
                return note;
            };
            return CellRichText({
                Header: columnName || name,
                description,
                hiddenable: isBoolean(hiddenable) ? hiddenable : true,
                hiddenByDefault: !isVisible,
                hidden,
                fixable: isBoolean(fixable) ? fixable : true,
                fixed,
                readOnly,
                actions: (instance, cell) => ['edit', 'past', 'copy', 'delete'],
                actionsIfNotValidContent: (instance, cell) => ['edit', 'past'],
                checkValidContent: (cell) => {
                    const { postBoardLinksInst } = cell.row.original;
                    const note = findNote(postBoardLinksInst);
                    if (!note) {
                        return _jsx("div", { className: "lightgrey fullWidth fullHeight flex center alignCenter", children: "No note" });
                    }
                    return undefined;
                },
                accessor: (item) => {
                    var _a;
                    if (!item)
                        return '';
                    const { postBoardLinksInst } = item;
                    return ((_a = findNote(postBoardLinksInst)) === null || _a === void 0 ? void 0 : _a.text) || '';
                },
                showHistoryParams: (instance, cell) => {
                    const { row: { original }, } = cell;
                    const note = findNote(original.postBoardLinksInst);
                    if (!note)
                        return null;
                    return {
                        assetId: note.id,
                        projectId,
                        resourceType: 'postBoardNotes',
                        title: `${step.name} note`,
                        requestName: 'history',
                        accessor: 'text',
                    };
                },
                id: String(timestamp),
                width: 300,
                extends: {
                    step,
                },
                reduxSave: {
                    bulk: true,
                    reduxAction: (values) => __awaiter(this, void 0, void 0, function* () {
                        const postBoardLinksToCreate = values
                            .flatMap((val) => val.postBoardLinksToCreate)
                            .filter((_) => _);
                        const postBoardNotesToCreate = values
                            .flatMap((val) => val.postBoardNotesToCreate)
                            .filter((_) => _);
                        const postBoardNotesToUpdate = values
                            .flatMap((val) => val.postBoardNotesToUpdate)
                            .filter((_) => _);
                        const promises = [];
                        if (postBoardLinksToCreate === null || postBoardLinksToCreate === void 0 ? void 0 : postBoardLinksToCreate.length) {
                            const text = values[0].text;
                            const step = values[0].step;
                            const res = yield dispatch(createPostBoardLink(postBoardLinksToCreate));
                            // @ts-expect-error
                            const postBoardNotes = res.payload.map((link) => ({
                                link: link.id,
                                text,
                                step: step ? step.id : null,
                            }));
                            promises.push(dispatch(createPostBoardNote(postBoardNotes)));
                        }
                        if (postBoardNotesToCreate === null || postBoardNotesToCreate === void 0 ? void 0 : postBoardNotesToCreate.length) {
                            promises.push(dispatch(createPostBoardNote(postBoardNotesToCreate)));
                        }
                        if (postBoardNotesToUpdate === null || postBoardNotesToUpdate === void 0 ? void 0 : postBoardNotesToUpdate.length) {
                            promises.push(dispatch(updatePostBoardNote(postBoardNotesToUpdate)));
                        }
                        return Promise.all(promises);
                    }),
                    getData: (data, newValue, type, instance, cell) => {
                        const postBoardLink = head(map(data.postBoardLinksInst));
                        if (!postBoardLink) {
                            const potentialEpisode = data.parent || getResources(undefined, 'assets', asset.parent);
                            const toCreate = { episode: potentialEpisode, asset: data.id, linkType: 'create', notes: [] };
                            return {
                                postBoardLinksToCreate: toCreate,
                                text: newValue,
                                step,
                            };
                        }
                        const { notesInst = [], id } = postBoardLink;
                        const note = notesInst.find(({ step: noteStep }) => {
                            if (noteStep === step.id || (noteStep === null && step.id === 'general'))
                                return true;
                            return false;
                        });
                        if (!note) {
                            const toCreate = { link: id, text: newValue, step: step.id === 'general' ? null : step.id };
                            return {
                                postBoardNotesToCreate: toCreate,
                                text: newValue,
                                step,
                            };
                        }
                        const toUpdate = { id: note.id, text: newValue };
                        return {
                            postBoardNotesToUpdate: toUpdate,
                            text: newValue,
                            step,
                        };
                    },
                },
            });
        }
        return CellNotesFollowUp({
            Header: columnName || name,
            description,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            readOnly,
            id: String(timestamp),
            step,
            getAsset: (cell) => cell.row.original,
            episodes,
            accessor: (item) => {
                return item.postBoardLinksInst;
            },
            reduxSave: {
                bulk: true,
                reduxAction: (values) => dispatch(updatePostBoardNote(values)),
                getData: (data, newValue, type, instance, cell) => newValue,
            },
        });
    }
    function renderTasksCell(column) {
        var _a;
        const { readOnly, isVisible = true, hidden, description, columnName, name, fixable, hiddenable, fixed, color, step, attr = '', timestamp, } = column;
        const cellContent = {
            id: String(timestamp),
            Header: columnName || name,
            headerColor: color,
            description,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            sortingKey: `step_${step}_${attr}`,
            fixed,
            readOnly: !permissions.tasks || (isBoolean(readOnly) ? readOnly : false),
            draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
            accessor: (item) => {
                if (!item)
                    return undefined;
                const task = find(item.tasksInst, (task) => task.step === step);
                if (!task)
                    return undefined;
                if (!task[attr])
                    return null;
                return task[attr] || null;
            },
            actions: (tableInstance, cell) => (cell.row.value ? ['edit', 'copy'] : ['copy']),
            reduxSave: {
                bulk: true,
                reduxAction: (values) => dispatch(updateTask(values)),
                getData: (data, newValue) => {
                    const task = find(data.tasksInst, (task) => task.step === step);
                    if (!task)
                        return null;
                    return {
                        id: task.id,
                        [attr]: newValue,
                    };
                },
            },
            Placeholder: (instance) => {
                const task = find(instance.cell.row.original.tasksInst, (task) => task.step === step);
                if (!task)
                    return _jsx("div", { className: "fullHeight flex center alignCenter lightgrey fontSize11", children: "No task" });
                return undefined;
            },
        };
        switch (attr) {
            case 'priority':
                return CellPriority(Object.assign(Object.assign({}, cellContent), { actions: (instance, cell) => {
                        if (cell.value !== undefined)
                            return ['edit', 'copy', 'past', 'delete'];
                        return [];
                    }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => dispatch(updateTask(values)),
                        getData: (data, newValue, type) => {
                            const task = find(data.tasksInst, (task) => task.step === step);
                            if (!task)
                                return null;
                            if (type === 'delete')
                                newValue = 0;
                            return {
                                id: task.id,
                                [attr]: newValue || 0,
                            };
                        },
                    } }));
            case 'startDate':
            case 'endDate':
            case 'earliestStartDate':
            case 'latestEndDate': {
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        type: 'date',
                    }, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        if (!task)
                            return undefined;
                        if (!task[attr])
                            return null;
                        return moment(task[attr]).format('YYYY-MM-DD');
                    }, Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return _jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "tasks", fields: [attr] });
                    }, actions: (instance, cell) => {
                        if (cell.value !== undefined)
                            return ['edit', 'copy', 'past'];
                        return [];
                    }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => dispatch(updateTask(values)),
                        getData: (data, newValue) => {
                            const task = find(data.tasksInst, (task) => task.step === step);
                            if (!task)
                                return null;
                            return {
                                id: task.id,
                                [attr]: moment(newValue, 'YYYY-MM-DD').toISOString(),
                            };
                        },
                    } }));
            }
            case 'status':
                return CellStatus(Object.assign(Object.assign({}, cellContent), { Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsStatus, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), progressionStatus: progressionStatus, columnName: columnName }));
                    }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => {
                            return dispatch(updateTake(values));
                        },
                        getData: (data, newValue) => {
                            const lastTake = getLastTakeFromAsset(data, column);
                            if (!lastTake)
                                return null;
                            return {
                                id: lastTake && lastTake.id,
                                [attr]: newValue,
                            };
                        },
                    }, actions: (instance, cell) => {
                        if (cell.value !== undefined)
                            return ['edit', 'copy', 'past'];
                        return [];
                    }, progressionStatus }));
            case 'assignedUser':
                return CellAssetsSelect(Object.assign(Object.assign({}, cellContent), { Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return _jsx(CellStatsAssignedUsers, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), columnName: columnName });
                    }, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        if (!task)
                            return undefined;
                        if (!task.assignedUser)
                            return null;
                        return task.assignedUserInst;
                    }, adornment: (cell) => {
                        var _a, _b;
                        const task = find((_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.tasksInst, (task) => task.step === step);
                        const suggestedUserName = task && !task.assignedUser && ((_b = task.suggestedUserInst) === null || _b === void 0 ? void 0 : _b.name);
                        return suggestedUserName ? (_jsxs("span", { className: "absolute grey fontSize12", style: { zIndex: 1, top: 0, left: 5 }, children: [_jsx(FontIcon, { icon: "fas-scroll", className: "marginRight5 fontSize10" }), _jsx("span", { style: {
                                        borderRadius: 3,
                                        backgroundColor: '#008AE6',
                                        color: '#fff',
                                        padding: '0px 5px',
                                        marginRight: 5,
                                    }, children: suggestedUserName }), "is suggested"] })) : null;
                    }, actions: (instance, cell) => {
                        var _a, _b, _c;
                        const task = find((_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.tasksInst, (task) => task.step === step);
                        const shouldHaveSuggestMenu = Boolean(task && !task.assignedUser && ((_b = task.suggestedUserInst) === null || _b === void 0 ? void 0 : _b.id));
                        if (!task)
                            return [];
                        if (task && !shouldHaveSuggestMenu)
                            return ['edit', 'delete', 'copy', 'past'];
                        const { state: { selectedCells }, } = instance.getLastestInstance();
                        const autoAssigneSuggestion = {
                            label: Object.keys(selectedCells || {}).length > 1
                                ? 'Assign suggestions'
                                : `Assign ${((_c = task.suggestedUserInst) === null || _c === void 0 ? void 0 : _c.name) || 'suggestion'}`,
                            rightLabel: 'Ctrl + A',
                            editAction: true,
                            onClick: (event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                const { getLastestSelection } = instance.getLastestInstance();
                                forEach(getLastestSelection().selectedCells, (_cell, cellId) => {
                                    var _a, _b, _c;
                                    const _task = find((_a = _cell.row.original) === null || _a === void 0 ? void 0 : _a.tasksInst, (_task) => _task.step === step);
                                    const suggestedUserId = _task && !_task.assignedUser && ((_b = _task.suggestedUserInst) === null || _b === void 0 ? void 0 : _b.id);
                                    if (suggestedUserId)
                                        (_c = _cell.getCellProps().edition) === null || _c === void 0 ? void 0 : _c.saveTargetOnly({ id: suggestedUserId });
                                });
                            },
                            hotKeys: ['ctrl+a', 'command+a'],
                        };
                        return [autoAssigneSuggestion, { separator: true }, 'edit', 'delete', 'copy', 'past'];
                    }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => dispatch(updateTask(values)),
                        getData: (data, newValue, type) => {
                            const task = find(data.tasksInst, (task) => task.step === step);
                            if (!task)
                                return null;
                            if (type === 'past') {
                                return {
                                    id: task.id,
                                    assignedUser: (newValue === null || newValue === void 0 ? void 0 : newValue.id) || null,
                                };
                            }
                            return {
                                id: task.id,
                                [attr]: (newValue === null || newValue === void 0 ? void 0 : newValue.id) || null,
                            };
                        },
                    }, sortingKey: `step_${step}_${attr}__name`, assetTypes: ['us'], placeholder: 'Assign an user' }));
            // TO DO: check what is taskViewersInst
            case 'taskViewersInst':
                return CellAssetsSelect(Object.assign(Object.assign({}, cellContent), { accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        return task === null || task === void 0 ? void 0 : task.taskViewersInst;
                    }, placeholder: 'Select viewers', multiple: true, assetTypes: ['us'], foreignKey: 'task', getResourceId: (cell) => { var _a; return find((_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.tasksInst, (task) => task.step === step) || ''; }, reduxSave: {
                        bulk: true,
                        reduxAction: (values) => console.log('values', values),
                        getData: (data, newValue, type) => {
                            const task = find(data.tasksInst, (task) => task.step === step);
                            if (!task)
                                return null;
                            const request = [];
                            const alreadyCreated = [];
                            newValue.forEach((taskViewer) => {
                                if (taskViewer.id) {
                                    alreadyCreated.push(taskViewer.id);
                                    return;
                                }
                                request.push(Object.assign(Object.assign({}, taskViewer), { assetInst: undefined }));
                            });
                            if (task && task.taskViewersInst) {
                                forEach(task.taskViewersInst, (rel) => {
                                    if (alreadyCreated.indexOf(rel.id) === -1) {
                                        request.push(rel.id);
                                    }
                                });
                            }
                            return request;
                        },
                    } }));
            case 'activitiesInst':
                return CellDuration(Object.assign(Object.assign({}, cellContent), { actions: () => [], noFilterOption: true, sortingKey: undefined, Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return _jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "activities" });
                    }, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        if (!task)
                            return undefined;
                        if (!task.activitiesInst)
                            return null;
                        return reduce(task.activitiesInst, (a, b) => a + b.duration, 0);
                    } }));
            case 'quoteEstimLength':
                return CellDuration(Object.assign(Object.assign({}, cellContent), { actions: () => [], accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        if (!task)
                            return undefined;
                        return task.quoteEstimLength;
                    }, Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "tasks", fields: ['quoteEstimLength'] }));
                    } }));
            case 'realEstimLength':
                return CellDuration(Object.assign(Object.assign({}, cellContent), { actions: (instance, cell) => (regex.exist(cell.value) ? ['edit', 'copy', 'past'] : []), accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        if (!task)
                            return undefined;
                        return task.realEstimLength;
                    }, Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "tasks", fields: ['realEstimLength'] }));
                    } }));
            case 'estimLength':
                return CellDuration(Object.assign(Object.assign({}, cellContent), { actions: () => [], Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "tasks", fields: ['estimLength'] }));
                    }, sortingKey: undefined, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        if (!task)
                            return undefined;
                        if (!task.takesInst)
                            return null;
                        return reduce(task.takesInst, (a, b) => a + b.estimLength, 0);
                    } }));
            case 'difference':
                return CellProgression(Object.assign(Object.assign({}, cellContent), { noFilterOption: true, sortingKey: undefined, readMask: (value) => DurationRead({ value }), accessor: (item) => {
                        if (!item)
                            return undefined;
                        const task = find(item.tasksInst, (task) => task.step === step);
                        if (!task)
                            return undefined;
                        if (!task.activitiesInst)
                            return null;
                        const totalDuration = reduce(task.activitiesInst, (a, b) => a + b.duration, 0);
                        const estimLength = reduce(task.takesInst, (a, b) => a + b.estimLength, 0);
                        return {
                            max: estimLength,
                            value: totalDuration,
                        };
                    }, actions: () => [] }));
            case 'name':
                return CellText(Object.assign(Object.assign({}, cellContent), { Stats: (instance) => {
                        const { stats } = instance;
                        if (!stats)
                            return null;
                        const stepStats = { default: stats[`step_${step}`] };
                        return (_jsx(CellStatsDefault, { instance: Object.assign(Object.assign({}, instance), { stats: stepStats }), resource: "tasks", updateFields: (entry) => {
                                var _a;
                                if (typeof entry === 'object') {
                                    if (entry.step_id) {
                                        return {
                                            Step: ((_a = steps[entry.step_id]) === null || _a === void 0 ? void 0 : _a.name) || '?',
                                            count: entry.count,
                                        };
                                    }
                                    if (entry.asset__parent__name) {
                                        return {
                                            'Parent name': entry.asset__parent__name,
                                            'Asset type': entry.asset__parent__assetType,
                                            count: entry.count,
                                        };
                                    }
                                }
                                return entry;
                            } }));
                    }, actions: (tableInstance, cell) => (cell.row.value ? ['edit', 'copy', 'past'] : []) }));
            default:
                return null;
            // throw new Error(`unknow task attr ${attr}`)
        }
    }
    function renderAttributeCell(column) {
        var _a;
        const { id, readOnly, isVisible = true, hidden, description, columnName, name, hiddenable, fixable, fixed, color, timestamp, } = column;
        const attributeId = id;
        const attribute = Object.assign({}, attributes[attributeId]);
        if (column.editorType !== attribute.editorType) {
            attribute.editorType = column.editorType;
            attribute.editorParams = column.editorParams;
        }
        const cellContent = {
            id: String(timestamp),
            Header: columnName || name,
            headerColor: color,
            description,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            readOnly: !permissions.attributes || (isBoolean(readOnly) ? readOnly : false),
            draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
            sortingKey: `attributes__${attribute.name}`,
            menuActions: ['duration', 'integer'].includes(attribute.attrType),
            Stats: (instance) => {
                let formatValue = () => { };
                let formatLabel = () => { };
                let radialLabel = () => { };
                if (['rating', 'priority', 'text'].includes(attribute.editorType)) {
                    formatLabel = (val) => viewableValue(attribute.attrType, val, attribute.editorType) || 'null';
                    if (attribute.editorType === 'rating')
                        radialLabel = (values) => padEnd('★'.repeat(Number(values.label)), 5, '☆');
                }
                else {
                    // $FlowFixMe
                    formatValue = (val) => {
                        if (attribute.editorType === 'smartdate')
                            return val;
                        return viewableValue(attribute.attrType, val, attribute.editorType, attribute.editorParams) || 'null';
                    };
                }
                return (_jsx(CellStatsAttributes, { instance: instance, name: attribute.name, formatValue: formatValue, formatLabel: formatLabel, radialLabel: radialLabel, showModal: ['smartdate'].includes(attribute.editorType) }));
            },
            accessor: `attributes.${attribute.name}`,
            actions: () => ['edit', 'delete', 'copy', 'past'],
            reduxSave: {
                bulk: true,
                reduxAction: (values) => {
                    return dispatch(updateFUAsset(values));
                },
                getData: (data, newValue, type) => {
                    if (type === 'delete') {
                        return {
                            id: data.id,
                            attributes: Object.assign(Object.assign({}, data.attributes), { [attribute.name]: null }),
                        };
                    }
                    return {
                        id: data.id,
                        attributes: Object.assign(Object.assign({}, data.attributes), { [attribute.name]: newValue }),
                    };
                },
            },
        };
        const createMinMaxValidator = ({ min, max }, errorLabel, format = (data) => data) => {
            const validators = {};
            if (min)
                validators.min = (value) => (format(value) < format(min) ? `${errorLabel} must be grather than ${min}` : false);
            if (max)
                validators.max = (value) => (format(value) > format(max) ? `${errorLabel} must be lower than ${max}` : false);
            return validators;
        };
        if (attribute.editorType === 'choice') {
            const options = () => {
                var _a, _b;
                const label = (value) => {
                    const str = viewableValue(attribute.attrType, value, attribute.editorType);
                    return str ? String(str) : '';
                };
                return (((_b = (_a = attribute === null || attribute === void 0 ? void 0 : attribute.editorParams) === null || _a === void 0 ? void 0 : _a.choice) === null || _b === void 0 ? void 0 : _b.map((value) => ({
                    value,
                    label: label(value),
                }))) || []);
            };
            return CellSelect(Object.assign(Object.assign({}, cellContent), { readMask: (value) => {
                    if (attribute.attrType === 'datetime')
                        return dateToLocaleStringFull(value);
                    return value;
                }, accessor: (item) => {
                    if (!item)
                        return '';
                    const { attributes } = item;
                    if (!attributes)
                        return '';
                    if (attribute.attrType === 'integer' && attributes[attribute.name]) {
                        return String(attributes[attribute.name]);
                    }
                    if (attribute.attrType === 'datetime' && attributes[attribute.name]) {
                        const datetime = new Date(attributes[attribute.name]);
                        return datetime.toISOString();
                    }
                    if (attribute.attrType === 'time' && attributes[attribute.name]) {
                        return moment(attributes[attribute.name], 'HH:MM:SS').format('HH:MM');
                    }
                    return attributes[attribute.name];
                }, reduxSave: {
                    bulk: true,
                    reduxAction: (values) => dispatch(updateFUAsset(values)),
                    getData: (data, newValue, type) => {
                        let returnedValue = newValue;
                        if (type === 'delete')
                            return { id: data.id, attributes: { [attribute.name]: null } };
                        if (attribute.attrType === 'datetime' && typeof newValue === 'string')
                            returnedValue = new Date(newValue);
                        return { id: data.id, attributes: Object.assign(Object.assign({}, data.attributes), { [attribute.name]: returnedValue }) };
                    },
                }, options }));
        }
        switch (attribute.attrType) {
            case 'bool': {
                return CellCheckbox(Object.assign(Object.assign({}, cellContent), { disableOnBlur: true }));
            }
            case 'char': {
                const { colored } = attribute.editorParams;
                return CellText(Object.assign(Object.assign({}, cellContent), { colored, noReadStyle: colored, actions: () => ['edit', 'delete', 'copy', 'past'], width: 200 }));
            }
            case 'date': {
                const validators = {};
                const { min, max } = attribute.editorParams;
                if (min) {
                    validators.min = (value) => {
                        return new Date(value) < new Date(min)
                            ? `date must be grather than ${new Date(min).toLocaleDateString()}`
                            : false;
                    };
                }
                if (max) {
                    validators.max = (value) => {
                        return new Date(value) > new Date(max)
                            ? `date must be lower than ${new Date(max).toLocaleDateString()}`
                            : false;
                    };
                }
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        type: 'date',
                        validators,
                    } }));
            }
            case 'datetime': {
                const { min, max } = attribute.editorParams;
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        min: min ? new Date(min) : undefined,
                        max: max ? new Date(max) : undefined,
                        type: 'datetime',
                    } }));
            }
            case 'smartdate': {
                return CellSmartDate(Object.assign(Object.assign({}, cellContent), { width: 200 }));
            }
            case 'duration': {
                const { hoursInDay } = attribute.editorParams;
                return CellDuration(Object.assign(Object.assign({}, cellContent), { hoursInDay, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const { attributes } = item;
                        if (!attributes)
                            return undefined;
                        return attributes[attribute.name];
                    } }));
            }
            case 'email': {
                return CellText(Object.assign(Object.assign({}, cellContent), { width: 150, inputProps: {
                        type: 'email',
                        validators: {
                            email: (value) => {
                                return !regex.is.email.test(value) && regex.exist(value) ? 'Invalide email' : false;
                            },
                        },
                    } }));
            }
            case 'float': {
                const { min, max, step } = attribute.editorParams;
                const validators = createMinMaxValidator({ min, max }, 'float', (data) => Number(data));
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        type: 'number',
                        min,
                        max,
                        step,
                        validators,
                    } }));
            }
            case 'integer': {
                if (attribute.editorType === 'timecode') {
                    const { framerate } = (column === null || column === void 0 ? void 0 : column.editorParams) || {};
                    return CellTimecode(Object.assign(Object.assign({}, cellContent), { framerate }));
                }
                if (attribute.editorType === 'rating') {
                    return CellRating(Object.assign({}, cellContent));
                }
                const { min, max, step, colored } = attribute.editorParams;
                const validators = createMinMaxValidator({ min, max }, 'integer', (data) => Number(data));
                return CellText(Object.assign(Object.assign({}, cellContent), { colored, noReadStyle: colored, inputProps: {
                        type: 'number',
                        min,
                        max,
                        step,
                        validators: Object.assign({ noFloat: (value) => {
                                const isInt = regex.is.integer.test(value) || !regex.exist(value);
                                return !isInt ? `It's not an integer` : false;
                            } }, validators),
                    } }));
            }
            case 'ip': {
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        type: 'ip',
                        validators: {
                            ip: (value) => {
                                return !regex.is.ip.test(value) && regex.exist(value) ? 'Invalide IP' : false;
                            },
                        },
                    } }));
            }
            case 'text': {
                return CellRichText(Object.assign(Object.assign({}, cellContent), { width: 200 }));
            }
            case 'time': {
                const { min, max } = attribute.editorParams;
                const validators = createMinMaxValidator({ min, max }, 'time');
                return CellText(Object.assign(Object.assign({}, cellContent), { accessor: (item) => {
                        var _a;
                        return (_a = item === null || item === void 0 ? void 0 : item.attributes) === null || _a === void 0 ? void 0 : _a[attribute.name];
                    }, inputProps: {
                        type: 'time',
                        validators,
                    } }));
            }
            case 'url': {
                return CellText(Object.assign(Object.assign({}, cellContent), { width: 150, inputProps: {
                        type: 'url',
                        validators: {
                            url: (value) => {
                                return !regex.is.url.test(value) && regex.exist(value) ? 'Invalide URL' : false;
                            },
                        },
                    } }));
            }
            default:
                console.error(`unknow attribute type ${attribute.attrType}`);
                return null;
        }
    }
    function renderParentAttributeCell(column) {
        var _a;
        const { id, isVisible = true, hidden, description, columnName, name, hiddenable, fixable, fixed, color, timestamp, } = column;
        const attributeId = id;
        const attribute = attributes[attributeId];
        if (column.editorType !== attribute.editorType) {
            attribute.editorType = column.editorType;
            attribute.editorParams = column.editorParams;
        }
        const cellContent = {
            id: String(timestamp),
            Header: columnName || name,
            headerColor: color,
            description,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            readOnly: true,
            draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
            sortingKey: `parent__attributes__${attribute.name}`,
            Stats: (instance) => {
                let formatValue = () => { };
                let formatLabel = () => { };
                let radialLabel = () => { };
                if (['rating', 'priority', 'text'].includes(attribute.editorType)) {
                    formatLabel = (val) => viewableValue(attribute.attrType, val, attribute.editorType) || 'null';
                    if (attribute.editorType === 'rating')
                        radialLabel = (values) => padEnd('★'.repeat(Number(values.label)), 5, '☆');
                }
                else {
                    // $FlowFixMe
                    formatValue = (val) => {
                        if (attribute.editorType === 'smartdate')
                            return val;
                        return viewableValue(attribute.attrType, val, attribute.editorType) || 'null';
                    };
                }
                return (_jsx(CellStatsAttributes, { instance: instance, name: attribute.name, formatValue: formatValue, formatLabel: formatLabel, radialLabel: radialLabel, showModal: ['smartdate'].includes(attribute.editorType) }));
            },
            accessor: `parentInst.attributes.${attribute.name}`,
        };
        const createMinMaxValidator = ({ min, max }, errorLabel, format = (data) => data) => {
            const validators = {};
            if (min)
                validators.min = (value) => (format(value) < format(min) ? `${errorLabel} must be greather than ${min}` : false);
            if (max)
                validators.max = (value) => (format(value) > format(max) ? `${errorLabel} must be lower than ${max}` : false);
            return validators;
        };
        if (attribute.editorType === 'choice') {
            return CellSelect(Object.assign(Object.assign({}, cellContent), { readMask: (value) => {
                    if (attribute.attrType === 'datetime')
                        return dateToLocaleStringFull(value);
                    return value;
                }, accessor: (item) => {
                    if (!item)
                        return '';
                    const { parentInst: { attributes = {} } = {} } = item;
                    if (!attributes)
                        return '';
                    if (attribute.attrType === 'integer' && attributes[attribute.name]) {
                        return String(attributes[attribute.name]);
                    }
                    if (attribute.attrType === 'datetime' && attributes[attribute.name]) {
                        const datetime = new Date(attributes[attribute.name]);
                        return datetime.toISOString();
                    }
                    if (attribute.attrType === 'time' && attributes[attribute.name]) {
                        return moment(attributes[attribute.name], 'HH:MM:SS').format('HH:MM');
                    }
                    return attributes[attribute.name];
                }, options: () => [] }));
        }
        switch (attribute.attrType) {
            case 'bool': {
                return CellCheckbox(Object.assign(Object.assign({}, cellContent), { disableOnBlur: true }));
            }
            case 'char': {
                const { colored } = attribute.editorParams;
                return CellText(Object.assign(Object.assign({}, cellContent), { colored, noReadStyle: colored, width: 200 }));
            }
            case 'date': {
                const validators = {};
                const { min, max } = attribute.editorParams;
                if (min) {
                    validators.min = (value) => {
                        return new Date(value) < new Date(min)
                            ? `date must be grather than ${new Date(min).toLocaleDateString()}`
                            : false;
                    };
                }
                if (max) {
                    validators.max = (value) => {
                        return new Date(value) > new Date(max)
                            ? `date must be lower than ${new Date(max).toLocaleDateString()}`
                            : false;
                    };
                }
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        type: 'date',
                        validators,
                    } }));
            }
            case 'datetime': {
                const { min, max } = attribute.editorParams;
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        min: min ? new Date(min) : undefined,
                        max: max ? new Date(max) : undefined,
                        type: 'datetime',
                    } }));
            }
            case 'smartdate': {
                return CellSmartDate(Object.assign(Object.assign({}, cellContent), { width: 200 }));
            }
            case 'duration': {
                const { hoursInDay } = attribute.editorParams;
                return CellDuration(Object.assign(Object.assign({}, cellContent), { hoursInDay, accessor: (item) => {
                        if (!item)
                            return undefined;
                        const { parentInst: { attributes }, } = item;
                        if (!attributes)
                            return undefined;
                        return attributes[attribute.name];
                    } }));
            }
            case 'email': {
                return CellText(Object.assign(Object.assign({}, cellContent), { width: 150, inputProps: {
                        type: 'email',
                        validators: {
                            email: (value) => {
                                return !regex.is.email.test(value) && regex.exist(value) ? 'Invalide email' : false;
                            },
                        },
                    } }));
            }
            case 'float': {
                const { min, max, step } = attribute.editorParams;
                const validators = createMinMaxValidator({ min, max }, 'float', (data) => Number(data));
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        type: 'number',
                        min,
                        max,
                        step,
                        validators,
                    } }));
            }
            case 'integer': {
                if (attribute.editorType === 'timecode') {
                    const { framerate } = (column === null || column === void 0 ? void 0 : column.editorParams) || {};
                    return CellTimecode(Object.assign(Object.assign({}, cellContent), { framerate }));
                }
                if (attribute.editorType === 'rating') {
                    return CellRating(Object.assign({}, cellContent));
                }
                const { min, max, step, colored } = attribute.editorParams;
                const validators = createMinMaxValidator({ min, max }, 'integer', (data) => Number(data));
                return CellText(Object.assign(Object.assign({}, cellContent), { colored, noReadStyle: colored, inputProps: {
                        type: 'number',
                        min,
                        max,
                        step,
                        validators: Object.assign({ noFloat: (value) => {
                                const isInt = regex.is.integer.test(value) || !regex.exist(value);
                                return !isInt ? `It's not an integer` : false;
                            } }, validators),
                    } }));
            }
            case 'ip': {
                return CellText(Object.assign(Object.assign({}, cellContent), { inputProps: {
                        type: 'ip',
                        validators: {
                            ip: (value) => {
                                return !regex.is.ip.test(value) && regex.exist(value) ? 'Invalide IP' : false;
                            },
                        },
                    } }));
            }
            case 'text': {
                return CellRichText(Object.assign(Object.assign({}, cellContent), { width: 200 }));
            }
            case 'time': {
                const { min, max } = attribute.editorParams;
                const validators = createMinMaxValidator({ min, max }, 'time');
                return CellText(Object.assign(Object.assign({}, cellContent), { accessor: (item) => { var _a, _b; return (_b = (_a = item === null || item === void 0 ? void 0 : item.parentInst) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b[attribute.name]; }, inputProps: {
                        type: 'time',
                        validators,
                    } }));
            }
            case 'url': {
                return CellText(Object.assign(Object.assign({}, cellContent), { width: 150, inputProps: {
                        type: 'url',
                        validators: {
                            url: (value) => {
                                return !regex.is.url.test(value) && regex.exist(value) ? 'Invalide URL' : false;
                            },
                        },
                    } }));
            }
            default:
                console.error(`unknow attribute type ${attribute.attrType}`);
                return null;
        }
    }
    function renderStepCell(column) {
        var _a;
        const { id, timestamp, columnName, name, description, color, readOnly, hiddenable, isVisible = true, hidden, fixed, fixable, } = column;
        return CellTask({
            id: String(timestamp),
            Header: columnName || name,
            description,
            headerColor: color,
            hideTaskMenu: restrictedActions.includes('taskSheet'),
            readOnly: !permissions.steps || (isBoolean(readOnly) ? readOnly : false),
            draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixed,
            disableMultipleEditCheckboxes: true,
            fixable: isBoolean(fixable) ? fixable : true,
            searchFilterLabel: `${columnName || name} - brief`,
            useRedux: true,
            accessor: (item) => {
                if (!item)
                    return undefined;
                return find(item.tasksInst, (task) => task.step === id);
            },
            Stats: (instance, props) => {
                return (_jsx(CellStatsStep, { instance: instance, progressionStatus: progressionStatus, step: id, steps: steps, columnName: columnName || name }));
            },
            Placeholder: (instance) => {
                const task = find(instance.cell.row.original.tasksInst, (task) => task.step === id);
                if (!task)
                    return _jsx("div", { className: "fullHeight flex center alignCenter lightgrey fontSize11", children: "No task" });
                return undefined;
            },
            sortingKey: [
                { label: 'Status', key: `lastTake_${id}_status` },
                { label: 'Take number', key: `lastTake_${id}_number` },
                { label: 'Estimated length', key: `lastTake_${id}_estimLength` },
                { label: 'Updated at', key: `lastTake_${id}_updatedAt` },
                { label: 'Status updated at', key: `lastTake_${id}_statusUpdatedAt` },
                { label: 'Comment', key: `lastTake_${id}_comment` },
            ],
            step: steps[id],
            actions: (instance, cell) => ['edit', 'copy', 'past'],
            extends: {
                progressionStatus,
                parentId: asset === null || asset === void 0 ? void 0 : asset.id,
                assetType: trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.assetType,
                id,
                pushType: 'steps',
            },
            reduxSave: {
                bulk: true,
                reduxAction: (values) => {
                    const takesToUpdate = values.map((val) => { var _a; return (_a = val === null || val === void 0 ? void 0 : val.diffTaketoUpdate) !== null && _a !== void 0 ? _a : {}; }).filter((val) => !isEmpty(val));
                    const flagsToCreate = values.flatMap((val) => val.flagsToCreate);
                    const flagsToDelete = values.flatMap((val) => val.flagsToDelete);
                    const promises = [
                        takesToUpdate.length && dispatch(updateTake(takesToUpdate)),
                        flagsToCreate.length && dispatch(createTakeFlags(flagsToCreate)),
                        flagsToDelete.length && dispatch(deleteTakeFlags(flagsToDelete)),
                    ];
                    return Promise.all(promises);
                },
                getData: (data, newValue, type, instance) => {
                    var _a;
                    const task = (_a = data.tasksInst) === null || _a === void 0 ? void 0 : _a.find((task) => task.step === id);
                    if (!task)
                        return null;
                    const { flags = [] } = newValue, takeValues = __rest(newValue, ["flags"]);
                    delete takeValues.task;
                    const lastTake = getLastTakeFromTask(task);
                    if (isEmpty(newValue) || !lastTake)
                        return null;
                    const diffTake = {};
                    if (type === 'past') {
                        const { copiedCells } = instance.state;
                        const copiedCell = map(copiedCells)[0];
                        if (!copiedCell)
                            return null;
                        const lastCopiedTake = getLastTakeFromTask(copiedCell.value);
                        if (!lastCopiedTake)
                            return null;
                        diffTake.comment = lastCopiedTake.comment;
                        diffTake.status = lastCopiedTake.status;
                    }
                    else {
                        forEach(takeValues, (value, key) => {
                            if (lastTake && value !== lastTake[key])
                                diffTake[key] = value;
                            if (!lastTake)
                                diffTake[key] = value;
                        });
                    }
                    const previousTakeFlags = lastTake.takeFlagsInst;
                    const previousFlagsIds = previousTakeFlags.map((flag) => flag === null || flag === void 0 ? void 0 : flag.flag);
                    const newFlagsIds = flags.map((flag) => flag === null || flag === void 0 ? void 0 : flag.flag);
                    const flagsToCreate = flags
                        .filter((flagToSave) => !previousFlagsIds.includes(flagToSave.flag))
                        .map((flag) => ({ take: lastTake.id, flag: flag.flag }));
                    const flagsToDelete = previousTakeFlags.filter((previousFlag) => !newFlagsIds.includes(previousFlag.flag));
                    return {
                        diffTaketoUpdate: isEmpty(diffTake) ? {} : Object.assign({ id: lastTake.id }, diffTake),
                        flagsToCreate,
                        flagsToDelete,
                    };
                },
            },
        });
    }
    function renderDynamicApprovalCell(gettedColumn) {
        var _a, _b;
        const dynamicApproval = dynamicApprovals[gettedColumn.id];
        const column = Object.assign(Object.assign({}, gettedColumn), dynamicApproval);
        const { columnName, isVisible = true, hidden, name, description, hiddenable, readOnly, fixable, fixed, id, timestamp, targetStep, color, } = column;
        const dynamicApprovalId = id;
        return CellDynamicApproval({
            id: String(timestamp),
            useRedux: true,
            Header: columnName || name,
            headerColor: color,
            headerSubLabel: targetStep ? _jsx("span", { className: "grey", children: ` → ${(_a = steps[targetStep]) === null || _a === void 0 ? void 0 : _a.name}` }) : null,
            description,
            searchFilterLabel: `${columnName || name} - comment`,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            projectId,
            sortingKey: [
                { label: 'Status', key: `dynamicApproval_${dynamicApprovalId}_status` },
                { label: 'Author', key: `dynamicApproval_${dynamicApprovalId}_author__name` },
                { label: 'Status updated at', key: `dynamicApproval_${dynamicApprovalId}_statusUpdatedAt` },
                { label: 'Created at', key: `dynamicApproval_${dynamicApprovalId}_createdAt` },
                { label: 'Comment', key: `dynamicApproval_${dynamicApprovalId}_comment` },
            ],
            readOnly: !permissions.dynApp || (isBoolean(readOnly) ? readOnly : false),
            draggable: !((_b = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _b === void 0 ? void 0 : _b.lockColumnOrder),
            accessor: (item) => {
                if (!item || !item.dynamicApprovalValuesInst)
                    return undefined;
                const dynamicApproval = find(item.dynamicApprovalValuesInst, ({ dynamicApproval }) => dynamicApproval === dynamicApprovalId);
                if (!dynamicApproval) {
                    return {
                        dynamicApproval: dynamicApprovalId,
                        asset: item.id,
                    };
                }
                return dynamicApproval;
            },
            Stats: (instance) => {
                return (_jsx(CellStatsDynamicApprovals, { instance: instance, dynamicApprovalId: dynamicApprovalId, columnName: columnName }));
            },
            actions: (instance, cell) => {
                const { value: dynamicApproval } = cell;
                // $FlowFixMe
                return ['edit', dynamicApproval.id ? 'copy' : null, 'past', dynamicApproval.id ? 'delete' : null].filter((_) => _);
            },
            extends: {
                progressionStatus,
                parentId: asset === null || asset === void 0 ? void 0 : asset.id,
                id: dynamicApprovalId,
                pushType: 'dynamicApprovals',
                targetStep,
            },
            reduxSave: {
                bulk: true,
                reduxAction: (values) => {
                    const toCreate = values.flatMap((val) => val.toCreate).filter((_) => _);
                    const toUpdate = values.flatMap((val) => val.toUpdate).filter((_) => _);
                    const toDelete = values.flatMap((val) => val.toDelete).filter((_) => _);
                    const toDeleteIds = toDelete.map((id) => ({ id }));
                    return dispatch(createUpdateAndDeleteDynamicApprovalValue({ toCreate, toUpdate, toDelete: toDeleteIds }));
                },
                getData: (data, newValue, type, instance, cell) => {
                    var _a;
                    const { id, dynamicApproval, asset } = cell.value;
                    const user = (_a = store.getState()) === null || _a === void 0 ? void 0 : _a.user;
                    if (type === 'delete')
                        return { toDelete: id };
                    if (!newValue)
                        return null;
                    if (!id) {
                        return {
                            toCreate: {
                                id,
                                asset,
                                dynamicApproval,
                                status: newValue.status,
                                comment: newValue.comment,
                                author: user.asset,
                            },
                        };
                    }
                    return {
                        toUpdate: {
                            id,
                            asset,
                            dynamicApproval,
                            status: newValue.status,
                            comment: newValue.comment,
                            author: user.asset,
                        },
                    };
                },
            },
        });
    }
    function renderAggregated(column) {
        var _a, _b, _c, _d, _e;
        const { aggregateType, columnName, name, timestamp, hiddenable, isVisible = true, hidden, fixable, fixed, id, } = column;
        if (aggregateType === 'calculatedField') {
            const { aggregateDatas = {} } = column;
            const { name: _name } = aggregateDatas;
            const accessor = `aggregations.calculatedFields.${_name}`;
            const { description, color } = column;
            const calculatedFieldType = getCalculatedFieldType(column);
            const cellContent = {
                Header: columnName || name,
                headerColor: color,
                description,
                hiddenable: isBoolean(hiddenable) ? hiddenable : true,
                hiddenByDefault: !isVisible,
                hidden,
                fixable: isBoolean(fixable) ? fixable : true,
                fixed,
                readOnly: true,
                draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
                id: String(timestamp),
                accessor,
                actions: () => [],
            };
            switch (calculatedFieldType) {
                case 'duration': {
                    return CellAggregatedAttribute(Object.assign(Object.assign({}, cellContent), { attrName: 'duration', attrType: 'duration', editorType: 'duration' }));
                }
                case 'dynappsummary':
                    return CellAggregatedDynamicApproval(Object.assign(Object.assign({}, cellContent), { accessor: `${accessor}.status__counts`, extends: {
                            progressionStatus,
                        } }));
                case 'number': {
                    return CellText(Object.assign(Object.assign({}, cellContent), { cellExponent: (instance, cell) => {
                            var _a, _b;
                            const { updatedAt } = ((_b = (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.calculatedFieldsValueInst) === null || _b === void 0 ? void 0 : _b.find((cf) => cf.calculatedField === id)) || {};
                            if (!updatedAt)
                                return undefined;
                            return (_jsx(Tooltip, { title: `Last update ${moment(updatedAt).format('DD/MM/YYYY HH:mm')}`, children: _jsx("span", { className: "grey fontSize10", children: moment(updatedAt).format('DD/MM/YYYY HH:mm') }) }));
                        } }));
                }
                default:
                    throw new Error(`unknow calculated field type ${calculatedFieldType}`);
            }
        }
        if (aggregateType === 'assetLink') {
            const { category, description, length } = column;
            if (length) {
                return CellText({
                    Header: columnName || name,
                    description,
                    id: String(timestamp),
                    hiddenable: isBoolean(hiddenable) ? hiddenable : true,
                    hiddenByDefault: !isVisible,
                    hidden,
                    fixable: isBoolean(fixable) ? fixable : true,
                    fixed,
                    readOnly: true,
                    draggable: !((_b = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _b === void 0 ? void 0 : _b.lockColumnOrder),
                    accessor: (item) => {
                        var _a;
                        if (!item)
                            return [];
                        return (filter((_a = item === null || item === void 0 ? void 0 : item.aggregations) === null || _a === void 0 ? void 0 : _a.assetLinks, (link) => { var _a; return ((_a = link === null || link === void 0 ? void 0 : link.attributes) === null || _a === void 0 ? void 0 : _a.category) === category; }) || [])
                            .length;
                    },
                    width: 30,
                });
            }
            return CellAssetsList({
                Header: columnName || name,
                description,
                id: String(timestamp),
                disableClickableAssets: restrictedActions.includes('assetSheet'),
                hiddenable: isBoolean(hiddenable) ? hiddenable : true,
                hiddenByDefault: !isVisible,
                hidden,
                fixed,
                fixable: isBoolean(fixable) ? fixable : true,
                accessor: (item) => {
                    var _a;
                    if (!item)
                        return [];
                    return filter((_a = item === null || item === void 0 ? void 0 : item.aggregations) === null || _a === void 0 ? void 0 : _a.assetLinks, (link) => { var _a; return ((_a = link === null || link === void 0 ? void 0 : link.attributes) === null || _a === void 0 ? void 0 : _a.category) === category; }) || [];
                },
                width: 200,
                aggregated: true,
                readOnly: true,
                draggable: !((_c = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _c === void 0 ? void 0 : _c.lockColumnOrder),
                category,
                actions: () => [],
                onOpenItem: (asset) => {
                    router.goTo('index', { assetId: asset.id }, { rightPanel: true });
                },
            });
        }
        if (aggregateType === 'attributes') {
            const { aggregateDatas = {} } = column;
            const { name: attrName, attrType, editorType, description } = aggregateDatas;
            return CellAggregatedAttribute({
                Header: columnName || name,
                description,
                id: String(timestamp),
                hiddenable: isBoolean(hiddenable) ? hiddenable : true,
                hiddenByDefault: !isVisible,
                hidden,
                fixed,
                fixable: isBoolean(fixable) ? fixable : true,
                readOnly: true,
                draggable: !((_d = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _d === void 0 ? void 0 : _d.lockColumnOrder),
                accessor: (item) => {
                    var _a, _b;
                    return (_b = (_a = item === null || item === void 0 ? void 0 : item.aggregations) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b[attrName];
                },
                attrType,
                editorType,
                width: 200,
                attrName,
                actions: () => [],
            });
        }
        const { category, description } = column;
        return CellFlags({
            Header: columnName || name,
            description,
            id: String(timestamp),
            category,
            getResourceID: (cell) => { var _a; return (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.id; },
            foreignKey: 'asset',
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            fixed,
            fixable: isBoolean(fixable) ? fixable : true,
            aggregated: true,
            readOnly: true,
            draggable: !((_e = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _e === void 0 ? void 0 : _e.lockColumnOrder),
            accessor: (item) => {
                var _a;
                const flags = {};
                forEach(((_a = item === null || item === void 0 ? void 0 : item.aggregations) === null || _a === void 0 ? void 0 : _a.flags) || [], (flag) => {
                    flags[flag.id] = { asset: item.id, flag: flag.id, id: '', flagInst: flag };
                });
                return flags;
            },
            width: 200,
            actions: () => [],
        });
    }
    function renderCalculatedFieldCell(column) {
        var _a;
        const { columnName, name, description, color, hiddenable, isVisible = true, hidden, fixed, fixable, timestamp, id, } = column;
        const calculatedFieldType = getCalculatedFieldType(column);
        const cellContent = {
            Header: columnName || name,
            headerColor: color,
            description,
            hiddenable: isBoolean(hiddenable) ? hiddenable : true,
            hiddenByDefault: !isVisible,
            hidden,
            sortingKey: `calculatedField_${id}`,
            fixable: isBoolean(fixable) ? fixable : true,
            fixed,
            readOnly: true,
            draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
            id: String(timestamp),
            Stats: (instance) => _jsx(CellStatsCalculatedFields, { instance: instance, id: id }),
            accessor: (item) => {
                var _a, _b;
                return (_b = (_a = item === null || item === void 0 ? void 0 : item.calculatedFieldsValueInst) === null || _a === void 0 ? void 0 : _a.find((cf) => cf.calculatedField === id)) === null || _b === void 0 ? void 0 : _b.value;
            },
            actions: () => [],
        };
        switch (calculatedFieldType) {
            case 'number': {
                return CellText(Object.assign(Object.assign({}, cellContent), { cellExponent: (instance, cell) => {
                        var _a, _b;
                        const { updatedAt } = ((_b = (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.calculatedFieldsValueInst) === null || _b === void 0 ? void 0 : _b.find((cf) => cf.calculatedField === id)) || {};
                        if (!updatedAt)
                            return undefined;
                        return (_jsx(Tooltip, { title: `Last update ${moment(updatedAt).format('DD/MM/YYYY HH:mm')}`, children: _jsx("span", { className: "grey fontSize10", children: moment(updatedAt).format('DD/MM/YYYY HH:mm') }) }));
                    } }));
            }
            case 'duration':
                return CellDuration(Object.assign(Object.assign({}, cellContent), { cellExponent: (instance, cell) => {
                        var _a, _b;
                        const { updatedAt } = ((_b = (_a = cell.row.original) === null || _a === void 0 ? void 0 : _a.calculatedFieldsValueInst) === null || _b === void 0 ? void 0 : _b.find((cf) => cf.calculatedField === id)) || {};
                        if (!updatedAt)
                            return undefined;
                        return (_jsx(Tooltip, { title: `Last update ${moment(updatedAt).format('DD/MM/YYYY HH:mm')}`, children: _jsx("span", { className: "grey fontSize10", children: moment(updatedAt).format('DD/MM/YYYY HH:mm') }) }));
                    } }));
            case 'dynappsummary': {
                return CellDynamicApproval(Object.assign(Object.assign({}, cellContent), { projectId, isSummary: true, noFilterOption: true, Stats: (instance) => {
                        return (_jsx(CellStatsDynamicApprovals, { isCalculatedField: true, instance: instance, dynamicApprovalId: id, columnName: columnName }));
                    }, extends: {
                        progressionStatus,
                        parentId: '',
                        id: '',
                        pushType: 'dynamicApprovals',
                    } }));
            }
            default:
                throw Error('Unknown calculated field type');
        }
    }
    function makeColumns() {
        var _a;
        return [
            {
                Header: 'Asset',
                id: 'headerAsset',
                columns: [
                    CellLink({
                        Header: 'Asset',
                        id: 'asset1',
                        fixed: 'left',
                        hiddenable: false,
                        readOnly: true,
                        draggable: !((_a = trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.settings) === null || _a === void 0 ? void 0 : _a.lockColumnOrder),
                        sortingKey: 'name',
                        showRemoved: true,
                        unselectable: true,
                        disableClick: restrictedActions.includes('assetSheet'),
                        accessor: 'name',
                        onClick: (row, e) => router.goTo('index', { assetId: row.original.id }, { rightPanel: true }),
                    }),
                ],
            },
            ...(trackingSchema
                ? trackingSchema.schema.map((groupColumn) => {
                    return {
                        Header: groupColumn.groupName,
                        description: groupColumn.description,
                        headerColor: groupColumn.color,
                        id: groupColumn.groupName,
                        columns: groupColumn.items.map((column) => {
                            switch (column.type) {
                                case 'lastTake':
                                    return renderLastTakeCell(column);
                                case 'assetLinks':
                                    return renderAssetLinks(column);
                                case 'assets':
                                    return renderAssetCell(column);
                                case 'postBoardNotes':
                                    return renderNotesCell(column);
                                case 'tasks':
                                    return renderTasksCell(column);
                                case 'attributes':
                                    return renderAttributeCell(column);
                                case 'parentAttributes':
                                    return renderParentAttributeCell(column);
                                case 'steps':
                                    return renderStepCell(column);
                                case 'dynamicApprovals':
                                    return renderDynamicApprovalCell(column);
                                case 'aggregation':
                                    return renderAggregated(column);
                                case 'calculatedField':
                                    return renderCalculatedFieldCell(column);
                                default:
                                    throw new Error(`Can't find this column type (${column.type})`);
                            }
                        }),
                    };
                })
                : []),
            ColumnTimeline({
                accessor: 'tasksInst',
                CellComponent: TimelineCellComponent,
                Drawer: TimelineDrawerComponentActivities,
                timelineEdition: (task, instance) => {
                    var _a, _b, _c, _d, _e;
                    if (!task)
                        return undefined;
                    const color = (ganttColorsType === 'status' ? (_a = task === null || task === void 0 ? void 0 : task.statusInst) === null || _a === void 0 ? void 0 : _a.color : (_b = task === null || task === void 0 ? void 0 : task.stepInst) === null || _b === void 0 ? void 0 : _b.color) || 'grey';
                    return {
                        resource: 'tasks',
                        id: task.id,
                        color,
                        label: `${(_c = task.stepInst) === null || _c === void 0 ? void 0 : _c.name} - ${((_d = task.assignedUserInst) === null || _d === void 0 ? void 0 : _d.name) || ((_e = task.suggestedUserInst) === null || _e === void 0 ? void 0 : _e.name) || ''}`,
                        contextMenuItems: [
                            {
                                label: 'Fit to activities',
                                onClick: () => fitToActivities(task, instance),
                                disabled: !permissions.timeline.startEndUpdate,
                            },
                        ],
                        start: {
                            position: 'start',
                            attr: 'startDate',
                            formatValue: (date) => date.toISOString(),
                            readOnly: !permissions.timeline.startEndUpdate,
                        },
                        end: {
                            position: 'end',
                            attr: 'endDate',
                            formatValue: (date) => date.toISOString(),
                            readOnly: !permissions.timeline.startEndUpdate,
                        },
                        earliest: {
                            position: 'earliest',
                            attr: 'earliestStartDate',
                            formatValue: (date) => date.toISOString(),
                            readOnly: !permissions.timeline.earliestLatestUpdate,
                        },
                        latest: {
                            position: 'latest',
                            attr: 'latestEndDate',
                            formatValue: (date) => date.toISOString(),
                            readOnly: !permissions.timeline.earliestLatestUpdate,
                        },
                    };
                },
            }),
        ];
    }
    const columns = useMemo(trackingSchema ? makeColumns : () => [], [trackingSchema, asset, ganttColorsType]);
    useEffect(() => {
        const url = filtersToURL(filtersData !== null && filtersData !== void 0 ? filtersData : []);
        routerHistory.updateQuery({ [getURLParamsKey('filters', tableId)]: url || null });
    }, [filtersData, trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.id]);
    useEffect(() => {
        if ((asset === null || asset === void 0 ? void 0 : asset.id) && (trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.id) && URLParamsParsed) {
            const { queries: filtQueries } = filtersToQueries(filtersForQueries !== null && filtersForQueries !== void 0 ? filtersForQueries : []);
            const queries = Object.assign({ page_size: (tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize) || (table === null || table === void 0 ? void 0 : table.pageSize) || 50, page: reduxPage + 1, ordering: ordering || 'name', uuid__in: assetId }, filtQueries);
            dispatch(fetchAssets({ id: directoryId, trackingSchemaId: trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.id, queries }));
        }
    }, [
        asset === null || asset === void 0 ? void 0 : asset.id,
        trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.id,
        directoryId,
        reduxPage,
        tableUserPrefs === null || tableUserPrefs === void 0 ? void 0 : tableUserPrefs.pageSize,
        ordering,
        filtersForQueries,
        URLParamsParsed,
    ]);
    return (_jsx(TableRedux, { filters: filters, allFilters: allFilters, showLockFilters: true, lockFilters: lockFilters, toggleButtons: toggleButtons, extendToolbar: extendToolbar, enableStats: !restrictedActions.includes('stats'), tableId: tableId, projectId: projectId, exportExcelFormat: restrictedActions.includes('exports') ? undefined : exportExcelFormat, columns: columns, rowExpander: true, isGantt: permissions.timeline.read ? showGantt : false, showGantt: permissions.timeline.read ? showGantt : false, getTimelineItems: (item) => item === null || item === void 0 ? void 0 : item.tasksInst.flatMap((task) => [
            task,
            map(task.activitiesInst, ({ date }) => ({ startDate: date, endDate: date })),
        ]), extendDatas: { asset, trackingSchemaId: (trackingSchema === null || trackingSchema === void 0 ? void 0 : trackingSchema.isExternal) ? trackingSchema.id : undefined }, loading: loading, count: count, data: data, trackingSchema: trackingSchema, 
        // loadingProgress={progress}
        progress: httpProgress, statsOpen: statsOpen, setStatsOpen: () => dispatch(setStatsOpen(!statsOpen)), stats: stats, statsIsLoading: statsIsLoading, page: reduxPage, setPage: (val) => dispatch(setTablePage(val)) }));
};
export default TableFollowUpRedux;
